export default __webpack_public_path__ + "static/media/iab-benefit-acquire.9cf5d342.svg";